import React from "react";
import Chart from "react-apexcharts";
import H5 from "../Typography/H5";
import { convertToInternationalCurrencySystem } from "../../helper";
import { mergeBarChartOptions } from "../../pages/Compare/chartTheme";

const Comparison: React.FC<any> = ({ data }): React.ReactElement => {
  const { series = [], categories = [], name = "", baseCurrency = "" } = data || {};

  const chartData: any = {
    options: mergeBarChartOptions({
      chart: {
        id: "Comparison",
      },
      xaxis: {
        categories,
      },
      yaxis: {
        labels: {
          formatter: (value: number) =>
            name === "Rev per Share" || name === "EPS Comparison"
              ? baseCurrency + " " + value.toFixed(2)
              : name === "Revenue Comparison"
              ? baseCurrency +
                " " +
                convertToInternationalCurrencySystem(String(value))
              : value.toFixed(2),
        },
      },
      plotOptions: {
        bar: {
          columnWidth: "90%",
          dataLabels: {
            orientation: "vertical",
          },
        },
      },
      dataLabels: {
        enabled: true,
        offsetY: 2,
        textAnchor: "start",
        formatter: (value: string) => {
          return name === "Revenue Comparison"
            ? convertToInternationalCurrencySystem(value)
            : (name === "Gross Margin Comparison" ||
                name === "Net Margin Comparison") &&
              value &&
              value != "0.00"
            ? Number(value).toFixed(2) + "%"
            : value
            ? Number(value).toFixed(2)
            : "";
        },
      },
    }),
    chart: {
      type: "bar",
    },
    series,
  };

  return (
    <div className="flex w-full flex-col p-4 w-auto vi-glass-card">
      <H5 color="text-[color:var(--vi-text)]">{name}</H5>
      <Chart
        options={chartData.options}
        series={chartData.series}
        type="bar"
        height={550}
      />
    </div>
  );
};

export default Comparison;
